export default "__VITE_ASSET__BzETkQU8__"